module.exports = __webpack_public_path__ + "static/media/13524569_10154374992349880_5351308249900190950_n.b771d962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/13524569_10154374992349880_5351308249900190950_n.jpg
// module id = 211
// module chunks = 0